import { IWorkroomDocument, IWorkroomFolder, WorkroomItemType } from 'Frontend/scripts/models/workrooms.model'
import React, { FunctionComponent, useEffect, useState, useRef } from 'react'
import { Form } from 'react-bootstrap'
import { convertDate } from 'Frontend/scripts/convertDates'
import { useWorkroom } from './WorkroomContext'

const WorkroomFolderTableRow: FunctionComponent<IWorkroomFolder | IWorkroomDocument> = (item) => {
  const {
    id,
    type,
    name,
    createdByUser,
    hasCurrentUserAccessToDelete,
    hasCurrentUserAccessToUpdate,
    updated,
    created,
  } = item
  const checkboxRef = useRef<HTMLInputElement>(null)
  const { addItem, removeItem, setCurrentActiveFolder } = useWorkroom()
  const [folderUrl, setFolderUrl] = useState<string>(window.location.pathname)

  let dateToShow = updated ? convertDate(updated) : convertDate(created)

  const disabled = !hasCurrentUserAccessToDelete && !hasCurrentUserAccessToUpdate

  const getFolderUrl = () => {
    const searchParams = new URLSearchParams(window.location.search)
    const params = new URLSearchParams(searchParams)
    params.set('folderId', id.toString())
    setFolderUrl(`${window.location.pathname}?${params.toString()}`)
  }

  const getUrl = () => {
    if (type === WorkroomItemType.FOLDER) return folderUrl
    return (item as IWorkroomDocument).url
  }

  const handleFolderClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    setCurrentActiveFolder(id.toString())
  }

  const handleFolderCheckboxClicked = (item: IWorkroomFolder | IWorkroomDocument) => {
    if (checkboxRef.current?.checked) addItem(item)
    else removeItem(item.id)
  }

  const createdBy = createdByUser
    ? createdByUser.firstname && createdByUser.lastname
      ? `${createdByUser.firstname} ${createdByUser.lastname}`
      : createdByUser.email?.toLowerCase()
    : 'Anonym'

  useEffect(() => {
    getFolderUrl()
  }, [])

  return (
    <tr>
      <td>
        <Form.Check type={'checkbox'} id="1" disabled={disabled}>
          <Form.Check.Input ref={checkboxRef} onClick={() => handleFolderCheckboxClicked(item)} />
          <Form.Check.Label className="visually-hidden">{`Välj mapp ${name}`}</Form.Check.Label>
        </Form.Check>
      </td>
      <td className="small">
        <i className={`fa text-secondary fa-${type === WorkroomItemType.FOLDER ? 'folder' : 'file-o'} me-2 `} />
        {type === WorkroomItemType.FILE ? (
          <a className="small" href={getUrl()} download={name}>
            {name}
          </a>
        ) : (
          <a className="small" href="#" onClick={handleFolderClick}>
            {name}
          </a>
        )}
      </td>
      <td className="small">{createdBy}</td>
      <td className="small text-end">{dateToShow}</td>
    </tr>
  )
}
export default WorkroomFolderTableRow
